import Text from './Text';
import CoordinateInput, { type Coordinate } from './CoordinateInput';
import SetupModeButton from './SetupModeButton';
import type { SetupModeBlockPosDto, SetupModeValueDto } from '../api/generated/schemas';
import styles from './AreaInput.module.css';

interface AreaInputProps {
    corner1: Coordinate;
    corner2: Coordinate;
    onChange: (corner1: Coordinate, corner2: Coordinate) => void;
    unit?: string;
    /** Unique within the page; the in-game capture comes back addressed to it. */
    fieldId: string;
    /** Shown in the in-game HUD, so it is already translated. */
    label: string;
    citybuild?: number | null;
    allowedBots: string[];
    anchor?: SetupModeBlockPosDto;
    reach?: number | null;
}

const isUnset = (corner: Coordinate) => !corner.x && !corner.y && !corner.z;

export default function AreaInput(props: AreaInputProps) {
    const currentRegion = (): SetupModeValueDto | undefined => {
        if (isUnset(props.corner1) && isUnset(props.corner2)) return undefined;
        return { kind: 'Region', region: { min: props.corner1, max: props.corner2 } };
    };

    const applyRegion = (value: SetupModeValueDto) => {
        if (!value.region) return;
        props.onChange(value.region.min, value.region.max);
    };

    return (
        <div class={styles.area}>
            <div class={styles.corner}>
                <div class={styles.cornerHeader}>
                    <span class={styles.cornerLabel}><Text val="AREA_CORNER_1" /></span>
                    <SetupModeButton
                        fieldId={props.fieldId}
                        kind="Region"
                        label={props.label}
                        citybuild={props.citybuild}
                        allowedBots={props.allowedBots}
                        currentValue={currentRegion}
                        anchor={props.anchor}
                        reach={props.reach}
                        onCaptured={applyRegion}
                    />
                </div>
                <CoordinateInput value={props.corner1} unit={props.unit}
                    onChange={(corner) => props.onChange(corner, props.corner2)} />
            </div>
            <div class={styles.corner}>
                <span class={styles.cornerLabel}><Text val="AREA_CORNER_2" /></span>
                <CoordinateInput value={props.corner2} unit={props.unit}
                    onChange={(corner) => props.onChange(props.corner1, corner)} />
            </div>
        </div>
    );
}
